<h2 mat-dialog-title class="flex items-center gap-2">
    <mat-icon svgIcon="heroicons_outline:lock-closed" class="text-warn"></mat-icon>
    Recurso indisponível
</h2>

<mat-dialog-content>
    <p class="text-secondary">
        O recurso <strong>{{ data.feature }}</strong> não está disponível no seu plano atual.
        Faça upgrade para desbloquear este e outros recursos.
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Fechar</button>
    <button mat-flat-button color="primary" (click)="goToUpgrade()">
        Ver planos
    </button>
</mat-dialog-actions>
